module.exports = __webpack_public_path__ + "img/dolce-and-gabbana_0.0ddcf0c8.jpg";